import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import SnackBar from '../General/SnackBar';
import { useEffect } from 'react';
import { GetDeviceList, PostHardWareRequest } from 'API/DS_Wallet/api';
import BackdropLoader from '../General/Loader';
import { getPincodeData } from 'API/AgentOnboarding/api';
import { IoIosRemoveCircle } from "react-icons/io";



const Hardware = () => {
    const [HardwareCategory, setHardwareCategory] = useState('select')
    const [OpenAert, setOpenAlert] = useState(false)
    const [AlertMessage, setAlertMessage] = useState('')
    const [AlertType, setAlertType] = useState('')
    const [PostData, setPostData] = useState({
        hardware_category: 'select',
        device: 'select',
        brand: 'select',
        modal: 'select',
        quantity: null,
        amount: 0
    })
    const [Address, setAddress] = useState({})
    const [DeviceData, setDeviceData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [PincodeData, setPincodeData] = useState(null)



    const [Data, setData] = useState([])

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }

    const handleCategoryChange = (event) => {
        setHardwareCategory(event.target.value)
    }

    const handleQuantityChange = (index, value) => {
        let copy = [...Data]
        copy[index].quantity = value ? value : ""
        setData(copy)
    }

    // console.log("Data", Data);

    useEffect(() => {
        GetDeviceList(setLoading, setDeviceData, handleAlertOpen)
    }, [])


    const handleDeviceChange = (name, value) => {
        if (value !== "select") {
            if(name ==="hardware_category"){
                setPostData({ ...PostData, [name]: value, device: 'select', brand: 'select', modal: 'select', quantity: null, amount: 0 })
            }
            else if (name === "device") {
                setPostData({ ...PostData, [name]: value, brand: 'select', modal: 'select', quantity: null, amount: 0 })
            }
            else if (name === "brand") {
                setPostData({ ...PostData, [name]: value, modal: 'select', quantity: null, amount: 0 })
            }

            else if (name === "modal") {

                setPostData({ ...PostData, [name]: value, amount: value.amount, quantity: 1 })
            }
            else {
                setPostData({ ...PostData, [name]: value, amount: 0, quantity: 0 })
            }
        }
        else {
            setPostData({ ...PostData, [name]: value, quantity: null, amount: 0 })
        }
    }

    const handleoneQuantityChange = (value) => {
        setPostData({ ...PostData, quantity: value })
    }

    const handleChangeCategory = (name, value) => {
        if (value !== 'select') {

            setPostData({ ...PostData, [name]: value , device: 'select', brand: 'select', modal: 'select', quantity: null, amount: 0 })
        }
        else {
            setPostData({
                hardware_category: 'select',
                device: 'select',
                quantity: null,
                amount: 0
            })
        }
    }

    const handleAdd = () => {

        if (!PostData.hardware_category || PostData.hardware_category === 'select') {
            handleAlertOpen('Please select a bank name', 'error')
        }
        else if (!PostData.device || PostData.device === 'select') {
            handleAlertOpen('Please select a device', 'error')
        }
        else if (!PostData.brand || PostData.brand === 'select') {
            handleAlertOpen('Please select a brand', 'error')
        }
        else if (!PostData.modal || PostData.modal === 'select') {
            handleAlertOpen('Please select a modal number', 'error')
        }

        else if (!PostData.quantity) {
            handleAlertOpen('Please enter a valid quantity', 'error')
        }
        else {
            if (Data.length > 0 && Data.find((item) => item.hardware_id === PostData.modal.hardware_id)) {
                handleAlertOpen('This device already exists in the list', 'error')
                
            }
            else {
                console.log("PostData",PostData);
                
                setData([...Data, { hardware_id: PostData.modal.hardware_id, quantity: PostData.quantity, amount: PostData.amount ,bank_name:PostData.hardware_category,device_name:PostData.device}])
                setPostData({
                    hardware_category: 'select',
                    device: 'select',
                    brand: 'select',
                    modal: 'select',
                    quantity: null,
                    amount: 0
                })
            }

        }
    }


    const handleRemove=(index)=>{
        let copy = [...Data]
        copy.splice(index, 1)
        setData(copy)
    }

    const handleForwardRequest = () => {
        let error = false
        let alertmessage = ""
        Data.map((item) => {
            console.log("item", item);

            item.quantity = parseInt(item.quantity)
            if (isNaN(item.quantity)) {
                alertmessage = "Please provide a valid quantity"
                error = true
                item.quantity = ""
            }
            else if (item.quantity < 1) {
                alertmessage = "Please provide a valid quantity"
                error = true
            }
        })

        if (Data.length === 0) {
            handleAlertOpen("Please add a device to proceed", 'error')
        }
        else if (! Address["address"] || Address["address"].length < 5) {
            handleAlertOpen("Please provide a valid address", 'error')
        }
        else if (!Address["pincode"] || Address["pincode"].length !==6) {
            handleAlertOpen("Please provide a valid pincode", 'error')
        }
        else if (!Address["city_village_name"] || Address["city_village_name"].length < 3) {
            handleAlertOpen("Please select a village", 'error')
        }
        else if (error) {
            handleAlertOpen(alertmessage, 'error')

        }
        else {
            PostHardWareRequest({
                delivery_address: Address,
                fwd_to_rm: false,
                hardware_data: Data
            },
                setLoading,
                handleAlertOpen,
                setData,
                setAddress
            )
        }
    }

    const handleForwardToRM = () => {
        let error = false
        let alertmessage = ""
        Data.map((item) => {
            console.log("item", item);

            item.quantity = parseInt(item.quantity)
            if (isNaN(item.quantity)) {
                alertmessage = "Please provide a valid quantity"
                error = true
                item.quantity = ""
            }
            else if (item.quantity < 1) {
                alertmessage = "Please provide a valid quantity"
                error = true
            }
        })

        if (Data.length === 0) {
            handleAlertOpen("Please add a device to proceed", 'error')
        }
        else if (! Address["address"] || Address["address"].length < 5) {
            handleAlertOpen("Please provide a valid address", 'error')
        }
        else if (!Address["pincode"] || Address["pincode"].length !==6) {
            handleAlertOpen("Please provide a valid pincode", 'error')
        }
        else if (!Address["city_village_name"] || Address["city_village_name"].length < 5) {
            handleAlertOpen("Please select a village", 'error')
        }
        else if (error) {
            handleAlertOpen(alertmessage, 'error')

        }
        else {
            PostHardWareRequest({
                delivery_address: Address,
                fwd_to_rm: true,
                hardware_data: Data
            },
                setLoading,
                handleAlertOpen,
                setData,
                setAddress
            )
        }
    }

    const handleAddressChange = (name, value) => {
        let postdata = { ...Address }

        switch (name) {
            case "address": {
                if (/^[a-zA-Z0-9/, ]*$|^$/.test(value)) {
                    postdata.address = value
                    break;

                }
                break;
            }
            case "landmark": {
                if (/^[a-zA-Z0-9/, ]*$|^$/.test(value)) {
                    postdata.landmark = value
                    break;

                }
                break;

            }
            case "pincode": {
                if (/^[0-9]*$|^$/.test(value) && value.length < 7) {
                    postdata.pincode = value
                    if (value.length === 6) {
                        getPincodeData(value, setPincodeData)
                    }

                    break;

                }
                break;

            }
            case "state": {
                if (/^[a-zA-Z0-9/, ]*$|^$/.test(value)) {
                    postdata.state = value
                    break;

                }
                break;

            }
            case "city_village_name": {
                if (/^[a-zA-Z0-9/, ]*$|^$/.test(value)) {
                    postdata.city_village_name = value
                    break;

                }
                break;

            }
            case "district": {
                if (/^[a-zA-Z0-9/, ]*$|^$/.test(value)) {
                    postdata.district = value
                    break;

                }
                break;

            }
            case "default":
                break;
        }

        setAddress(postdata)

    }


    console.log("Address", Address, PincodeData);


    useEffect(() => {
        if (PincodeData && PincodeData.length > 0) {
            let postdata = { ...Address }
            postdata.state = PincodeData[0].State
            postdata.district = PincodeData[0].District
            setAddress(postdata)
        }
    }, [PincodeData])

    // console.log("Post Data", PostData);


    return (
        <Grid container>
            <SnackBar open={OpenAert} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
            <BackdropLoader open={loading} />
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <MainCard>
                    <Grid container>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={HardwareCategory}
                                    label="Category"
                                    onChange={handleCategoryChange}
                                >

                                    <MenuItem value={'select'}>Select</MenuItem>
                                    {/* <MenuItem value={'signon'}>Sign On</MenuItem> */}
                                    <MenuItem value={'hardware'}>Hardware</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container mt={2} spacing={2}>

                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <FormControl 
                            fullWidth
                            required
                            sx={{
                                "& .MuiFormLabel-asterisk": {
                                  color: "red"
                                }
                              }}
                            >
                                <InputLabel id="demo-simple-select-label">Bank Name</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={PostData.hardware_category}
                                    label="Bank Name"

                                    onChange={(e) => handleChangeCategory('hardware_category', e.target.value)}
                                >
                                    <MenuItem value={'select'}>Select</MenuItem>
                                    {
                                        DeviceData && [...new Map(DeviceData.map(item => [item.bank_name, item])).values()].map((category, index) => (
                                            <MenuItem key={index} value={category.bank_name}>{category.bank_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <FormControl 
                            fullWidth
                            required
                            sx={{
                                "& .MuiFormLabel-asterisk": {
                                  color: "red"
                                }
                              }}>
                                <InputLabel id="demo-simple-select-label">Device</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={PostData.device}
                                    label="Device"
                                    onChange={(e) => handleDeviceChange('device', e.target.value)}
                                >
                                    <MenuItem value={'select'}>Select</MenuItem>
                                    {
                                        PostData.hardware_category &&
                                        PostData.hardware_category !== "select" &&
                                        DeviceData &&
                                        [...new Map(
                                            DeviceData
                                                .filter(item => item.bank_name === PostData.hardware_category)
                                                .map(item => [item.name, item])
                                        ).values()].map((item, index) => (
                                            <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <FormControl 
                                fullWidth
                                required
                            sx={{
                                "& .MuiFormLabel-asterisk": {
                                  color: "red"
                                }
                              }}>
                                <InputLabel id="demo-simple-select-label">Brand</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={PostData.brand}
                                    label="Brand"
                                    onChange={(e) => handleDeviceChange('brand', e.target.value)}
                                >
                                    <MenuItem value={'select'}>Select</MenuItem>
                                    {
                                        PostData.device && PostData.device !== "select" && DeviceData && DeviceData.filter((item) => item.bank_name === PostData.hardware_category && item.name === PostData.device).map((item, index) => (
                                            <MenuItem key={index} value={item.brand_name}>{item.brand_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <FormControl 
                            fullWidth
                            required
                            sx={{
                                "& .MuiFormLabel-asterisk": {
                                  color: "red"
                                }
                              }}>
                                <InputLabel id="demo-simple-select-label">Modal Number</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={PostData.modal}
                                    label="Modal Number"
                                    onChange={(e) => handleDeviceChange('modal', e.target.value)}
                                >
                                    <MenuItem value={'select'}>Select</MenuItem>
                                    {
                                        PostData.device && PostData.device !== "select" && DeviceData && DeviceData.filter((item) => item.bank_name === PostData.hardware_category && item.name === PostData.device && item.brand_name === PostData.brand).map((item, index) => (
                                            <MenuItem key={index} value={item}>{item.model}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <TextField
                                id="outlined-basic"
                                label="Amount"
                                variant="outlined"
                                value={PostData.amount}
                                sx={
                                    {
                                        input: {
                                            backgroundColor: "#f2f2f2"
                                        }
                                    }
                                }
                                inputProps={{
                                    readOnly: true
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                            <TextField
                                id="outlined-basic"
                                label="Quantity"
                                variant="outlined"
                                value={PostData.quantity ? PostData.quantity : ""}
                                inputProps={{
                                    readOnly: false
                                }}
                                fullWidth
                                onChange={(e) => {
                                    if (/^\d*$|^$/.test(e.target.value)) {
                                        handleoneQuantityChange(e.target.value)
                                    }
                                }
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid container mt={2} justifyContent='center'>
                        <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                            <Button fullWidth variant='contained' color='secondary' onClick={() => handleAdd()}>Add</Button>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} mt={2} padding={1}>
                <Divider />
            </Grid>
            <Grid mt={2} item xl={12} lg={12} md={12} sm={12} xs={12}>
                <MainCard title="Checkout">
                    <Grid container spacing={4}>
                        <Grid item xl={6} lg={6.5} md={12} sm={12} xs={12}>
                            {
                                Data && Data.length > 0 && Data.map((item, index) => (
                                    <Box key={index}  sx={{backgroundColor:"#f0f0f0",borderRadius:"10px",padding:"20px",marginBottom:"10px",position:"relative"}}>
                                        <Box sx={{position:"absolute",top:"-4px",right:"-17px"}}><Button variant='text' color='error' sx={{fontSize:"24px",cursor:"pointer"}} onClick={() => handleRemove(index)}><IoIosRemoveCircle /></Button></Box>
                                        <Typography variant='h4' >Device {index + 1}</Typography>
                                        <table style={{width:"100%"}}>
                                            <tr key={index} style={{width: '100%'}}>
                                                <th style={{ padding: '5px' ,textAlign:'left'}}>Bank Name</th>
                                                <th style={{ padding: '5px',textAlign:'left' }}>:</th>
                                                <td style={{ padding: '5px',textAlign:'left' }}>{item.bank_name}</td>
                                                <th style={{ padding: '5px',textAlign:'left' }}>Device</th>
                                                <th style={{ padding: '5px',textAlign:'left' }}>:</th>
                                                <td style={{ padding: '5px',textAlign:'left' }}>{item.device_name}</td>
                                            </tr>
                                            <tr key={index} style={{width: '100%'}}>
                                                <td style={{ padding: '5px' ,textAlign:'left'}}>Quantity</td>
                                                <td style={{ padding: '5px',textAlign:'left' }}>:</td>
                                                <td style={{ padding: '5px',textAlign:'left' }}>
                                                    <TextField
                                                        value={item.quantity}
                                                        onChange={(e) => {
                                                            if (/^\d*$|^$/.test(e.target.value)) {
                                                                handleQuantityChange(index, e.target.value)
                                                            }
                                                        }}
                                                        size='small'
                                                    />
                                                </td>
                                                <td style={{ padding: '5px',textAlign:'left' }}>Amount</td>
                                                <td style={{ padding: '5px',textAlign:'left' }}>:</td>
                                                <td style={{ padding: '5px',textAlign:'left' }}>{eval(item.quantity * item.amount)}</td>
                                            </tr>
                                        </table>
                                    </Box>
                                ))
                            }
                            <table>
                                <tr>

                                    <td style={{ padding: '5px' }}><Typography variant='h4'>Total</Typography></td>
                                    <td style={{ padding: '5px' }}>:</td>
                                    <td style={{ padding: '5px' }}>{Data.reduce((acc, curr) => acc + curr.quantity * curr.amount, 0)}</td>
                                </tr>
                            </table>
                        </Grid>
                        <Grid item xl={6} lg={5.5} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Dispatch Address"
                                        required
                                        InputLabelProps={{
                                            sx: {
                                              "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                              }
                                            }
                                          }}
                                        value={Address && Address["address"] ? Address["address"] : ""}
                                        multiline
                                        rows={1}
                                        fullWidth
                                        onChange={(e) => handleAddressChange("address", e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="outlined-basic"
                                        label="Pincode"
                                        required
                                        value={Address && Address["pincode"] ? Address["pincode"] : ""}
                                        InputLabelProps={{
                                            sx: {
                                              "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                              }
                                            }
                                          }}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleAddressChange("pincode", e.target.value)}

                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="outlined-basic"
                                        label="Landmark"
                                        value={Address && Address["landmark"] ? Address["landmark"] : ""}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleAddressChange("landmark", e.target.value)}

                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="outlined-basic"
                                        label="State"
                                        disabled
                                        required
                                        InputLabelProps={{
                                            sx: {
                                              "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                              }
                                            }
                                          }}
                                        value={Address && Address["state"] ? Address["state"] : ""}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleAddressChange("state", e.target.value)}

                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="outlined-basic"
                                        label="District"
                                        disabled
                                        required
                                        InputLabelProps={{
                                            sx: {
                                              "& .MuiFormLabel-asterisk": {
                                                color: "red"
                                              }
                                            }
                                          }}
                                        value={Address && Address["district"] ? Address["district"] : ""}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleAddressChange("district", e.target.value)}

                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl 
                                    fullWidth 
                                    required
                                   
                                        sx={{
                                          "& .MuiFormLabel-asterisk": {
                                            color: "red"
                                          }
                                        }}
                                      
                                    >
                                        <InputLabel id="demo-simple-select-label" >Village</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Village"
                                            required
                                            
                                            disabled={!PincodeData || PincodeData.length === 0}
                                            value={Address && Address["city_village_name"] ? Address["city_village_name"] : []}
                                            onChange={(e) => handleAddressChange("city_village_name", e.target.value)}

                                        >
                                            {PincodeData && PincodeData.map((name) => (
                                                <MenuItem key={name.AreaName} value={name.AreaName}>
                                                    {name.AreaName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid container justifyContent='center' gap={2}>
                <Grid item xl={3} lg={3} md={4} sm={12} xs={12}>
                    <Button fullWidth variant='contained' color='success' onClick={() => handleForwardRequest()}>Forward request to Procurement head</Button>
                </Grid>
                <Grid item xl={3} lg={3} md={4} sm={12} xs={12}>
                    <Button fullWidth variant='contained' color='secondary' onClick={() => handleForwardToRM()}>Send Request to Regional manager</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Hardware